import React from 'react';
import '../tools/css/EstadoVacio.css';

/**
 * Ilustración para los estados "sin información" de las tablas del portal —
 * reemplaza el gif genérico de carpeta por algo propio del sector salud
 * (carpeta clínica + pulso + lupa), animado sutilmente, en los colores de
 * marca. Se usa dentro del mismo <div id="empty_page..."> que ya controla
 * jQuery, así que no cambia ninguna lógica de mostrar/ocultar.
 */
function EstadoVacio(){
  return (
    <svg className="estado-vacio__ilustracion" viewBox="0 0 200 170" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Sin información">

      <ellipse className="estado-vacio__sombra" cx="100" cy="152" rx="55" ry="8" />

      <g className="estado-vacio__flotante">

        {/* Carpeta clínica */}
        <rect x="38" y="26" width="124" height="108" rx="14" className="estado-vacio__carpeta-fondo" />
        <rect x="78" y="14" width="44" height="20" rx="6" className="estado-vacio__carpeta-clip" />

        {/* Renglones vacíos */}
        <rect x="58" y="106" width="60" height="8" rx="4" className="estado-vacio__renglon" />
        <rect x="58" y="120" width="42" height="8" rx="4" className="estado-vacio__renglon" />

        {/* Pulso / EKG */}
        <path
          className="estado-vacio__pulso"
          d="M56 78 H74 L82 60 L92 96 L100 68 L108 84 H144"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Cruz médica */}
        <g className="estado-vacio__cruz">
          <rect x="94" y="34" width="12" height="28" rx="3" />
          <rect x="86" y="42" width="28" height="12" rx="3" />
        </g>

      </g>

      {/* Lupa */}
      <g className="estado-vacio__lupa">
        <circle cx="150" cy="118" r="20" />
        <line x1="163.5" y1="131.5" x2="180" y2="148" strokeLinecap="round" />
      </g>

    </svg>
  )
}

export default EstadoVacio;
